/**
 * Motion extras picked from the Waimers motion previews:
 *
 * 4. Word rotate - an element with data-word-rotate="a|b|c" cycles its word
 *    every 2.2s, the old word rolling up and out as the new one rolls in.
 *
 * Pointer-only effects are skipped on touch; everything respects reduced
 * motion.
 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* 4 ---------------------------------------------------------------- */
  function initRotate(root) {
    (root || document).querySelectorAll('[data-word-rotate]').forEach(function (box) {
      if (box.dataset.rotating) return;
      box.dataset.rotating = 'true';
      var words = box.getAttribute('data-word-rotate').split('|').filter(Boolean);
      if (words.length < 2 || reduce.matches) return;
      box.textContent = '';
      var cur = document.createElement('span');
      cur.className = 'word-rotate__word';
      cur.textContent = words[0];
      box.appendChild(cur);
      var i = 0;
      /* Only rotates while on screen. The tick used to read offsetWidth to
         start the roll-in, which forced a style pass over the whole page
         every 2.2s - on or off screen. Two frames give the browser its
         starting state without forcing anything. */
      var visible = true;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[entries.length - 1].isIntersecting;
        }).observe(box);
      }
      window.setInterval(function () {
        if (document.hidden || !visible) return;
        i = (i + 1) % words.length;
        var next = document.createElement('span');
        next.className = 'word-rotate__word is-in';
        next.textContent = words[i];
        box.appendChild(next);
        var old = cur;
        cur = next;
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            next.classList.remove('is-in');
            old.classList.add('is-out');
            window.setTimeout(function () { old.remove(); }, 700);
          });
        });
      }, 2200);
    });
  }

  /* 9 ---------------------------------------------------------------- */
  function initProgress() {
    var bar = document.querySelector('.scroll-progress');
    if (!bar) return;
    var ticking = false;
    function update() {
      ticking = false;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, window.scrollY / h) : 0) + ')';
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function init() {
    initRotate();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { initRotate(e.target); });
})();
